import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import DataTable from "../../components/Datatable/DataTable";
import Button from "../../components/Button/Button";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import StringInput from "../../components/Input/StringInput/StringInput";
import Select from "../../components/Input/Select/Select";
import moment from "moment";
import {
  getBonusClaimList,
} from "../../store/ducks/bonusClaim/actions";

class BonusClaimList extends Component {
  constructor(props) {
    super(props);
    const today = moment().format('YYYY/MM/DD');
    this.state = {
      showCard: true,
      data: [],
      totalRecords: 0,
      activePage: 1,
      limit: 10,
      loading: false,
      searchInput: {
        error: "",
        memberUsername: "",
        bonusSlug: "rescue-bonus", // Default to first option
        dateRange: `${today} - ${today}`, // Default to today
        startDate: today,
        endDate: today,
        gameTypeSlug: "ca", // Default to first option (Casino)
        isClaimed: "0", // Default to first option (Unclaimed)
      },
    };
  }

  rowNumberFormatter = (rowIndex) => {
    let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
    return <span>{rowNumber}</span>;
  }

  onChangeUsername = (e) => {
    this.setState({
      searchInput: {
        ...this.state.searchInput,
        memberUsername: e.target.value.trim(),
      },
    });
  };

  onChangeBonusSlug = (e) => {
    this.setState({
      searchInput: {
        ...this.state.searchInput,
        bonusSlug: e.target.value,
      },
    });
  };

  onChangeDateRange = (e) => {
    // Parse the date range string (e.g., "2025/07/07 - 2025/07/13")
    const dateRange = e.target.value;
    let startDate = '';
    let endDate = '';
    
    if (dateRange && dateRange.includes(' - ')) {
      const dates = dateRange.split(' - ');
      startDate = dates[0];
      endDate = dates[1];
    }
    
    this.setState({
      searchInput: {
        ...this.state.searchInput,
        dateRange: dateRange,
        startDate: startDate,
        endDate: endDate,
      },
    });
  };

  onChangeGameTypeSlug = (e) => {
    this.setState({
      searchInput: {
        ...this.state.searchInput,
        gameTypeSlug: e.target.value,
      },
    });
  };

  onChangeIsClaimed = (e) => {
    this.setState({
      searchInput: {
        ...this.state.searchInput,
        isClaimed: e.target.value,
      },
    });
  };

  onSearch = () => {
    this.setState({
      ...this.state,
      loading: true,
      searchInput: {
        ...this.state.searchInput,
        error: "",
      },
    }, () => {
      // Create the base parameters
      const params = {
        page: this.state.activePage,
        limit: this.state.limit,
        order: "desc",
        sort: "created_at",
      };

      // Only add non-empty parameters
      if (this.state.searchInput.memberUsername && this.state.searchInput.memberUsername.trim() !== '') {
        params.memberUsername = this.state.searchInput.memberUsername.trim();
      }
      
      if (this.state.searchInput.bonusSlug && this.state.searchInput.bonusSlug !== '') {
        params.bonusSlug = this.state.searchInput.bonusSlug;
      }
      
      if (this.state.searchInput.startDate && this.state.searchInput.startDate !== '') {
        params.startDate = this.state.searchInput.startDate;
      }
      
      if (this.state.searchInput.endDate && this.state.searchInput.endDate !== '') {
        params.endDate = this.state.searchInput.endDate;
      }
      
      if (this.state.searchInput.gameTypeSlug && this.state.searchInput.gameTypeSlug !== '') {
        params.gameTypeSlug = this.state.searchInput.gameTypeSlug;
      }
      
      if (this.state.searchInput.isClaimed && this.state.searchInput.isClaimed !== '') {
        params.isClaimed = this.state.searchInput.isClaimed;
      }

      this.props.getBonusClaimList(params);
    });
    
  };

  onReset = () => {
    this.setState({
      ...this.state,
      searchInput: {
        memberUsername: "",
        bonusSlug: "rescue-bonus",
        dateRange: `${moment().format('YYYY/MM/DD')} - ${moment().format('YYYY/MM/DD')}`,
        startDate: moment().format('YYYY/MM/DD'),
        endDate: moment().format('YYYY/MM/DD'),
        gameTypeSlug: "ca",
        isClaimed: "0",
      },
    }, () => this.onSearch());
  };

  onChangePage = (page) => {
    this.setState({
      ...this.state,
      activePage: Number(page),
    }, () => this.onSearch());
  };

  onChangeLimit = (limit) => {
    this.setState({
      ...this.state,
      limit: Number(limit),
    }, () => this.onSearch());
  };

  componentDidUpdate(prevProps) {

    if (
      prevProps.list !== this.props.list &&
      this.props.list &&
      this.props.list.data &&
      this.props.list.data.responseCode === 200 &&
      this.props.list.data.data &&
      this.props.list.data.data.result &&
      this.props.list.data.data.result.pagination &&
      this.props.list.data.data.result.row
    ) {

      let { data } = this.props.list;
      if (data) {
        this.setState({
          ...this.state,
          data: this.props.list.data.data.result.row,
          totalRecords: this.props.list.data.data.result.pagination.total_record || 0,
          activePage: this.props.list.data.data.result.pagination.current_page || 1,
          limit: Number(this.props.list.data.data.result.pagination.per_page) || 10,
          loading: false,
        });
      }
    }
    
  }

  // Hard-coded options for bonus slugs
  bonusSlugOptions = [
    { value: 'rescue-bonus', label: 'Rescue Bonus' },
  ];

  // Hard-coded options for game type slugs
  gameTypeSlugOptions = [
    { value: 'ca', label: 'Casino' },
    { value: 'sl', label: 'Slot' },
    { value: 'sp', label: 'Sport' },
  ];

  render() {
    let { t } = this.props;

    const columns = [
      {
        text: t("global.no"),
        dataField: "no",
        formatter: (cell, row, rowIndex) => this.rowNumberFormatter(rowIndex)
      },
      {
        text: t("member.username"),
        dataField: "username",
        sort: false,
      },
      {
        text: t("member.contact-no"),
        dataField: "contact_no",
        sort: false,
      },
      {
        text: t("global.total-credit"),
        dataField: "total_credit",
        sort: false,
      },
      {
        text: t("global.total-win-lose"),
        dataField: "total_win_lose",
        sort: false,
      },
      {
        text: t("global.net-win-lose"),
        dataField: "net_win_lose",
        sort: false,
      },
      {
        text: t("global.unclaimed-amount"),
        dataField: "unclaimed_amount",
        sort: false,
      },
    ];

    return (
      <Auxiliary>
        <div className="row row-sm">
          <div className="col-xl-12">
            <div className="card card-body">
              <div className="col mt-auto">
                {this.state.loading ? (
                  <Skeleton count={2} />
                ) : (
                  <div className={`form-horizontal filter-function row`}>
                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("global.member-username")}
                        </label>
                        <StringInput
                          id="username"
                          name="username"
                          value={this.state.searchInput.memberUsername}
                          onChange={this.onChangeUsername}
                          className="filter-input"
                          onSearchPress={(e) =>
                            e.key === "Enter" && this.onSearch()
                          }
                        />
                      </div>
                    </div>
                    {/* Bonus Slug */}
                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("global.bonus")}
                        </label>
                        <Select
                          id="bonusSlug"
                          name="bonusSlug"
                          value={this.state.searchInput.bonusSlug}
                          onChange={this.onChangeBonusSlug}
                          options={this.bonusSlugOptions}
                          getOptionLabel="label"
                          getOptionValue="value"
                          className="filter-input"
                          emptyValue={true}
                        />
                      </div>
                    </div>
                    {/* Date Range */}
                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("global.date-range")}
                        </label>
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="fas fa-calendar-check" />
                          </span>
                          <DateTimePicker
                            id="dateRange"
                            name="dateRange"
                            value={this.state.searchInput.dateRange}
                            onChange={this.onChangeDateRange}
                            className="form-control filter-input"
                            range={true}
                            placeholder={t("global.date-range")}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Game Type Slug */}
                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("global.game-type")}
                        </label>
                        <Select
                          id="gameTypeSlug"
                          name="gameTypeSlug"
                          value={this.state.searchInput.gameTypeSlug}
                          onChange={this.onChangeGameTypeSlug}
                          options={this.gameTypeSlugOptions}
                          getOptionLabel="label"
                          getOptionValue="value"
                          className="filter-input"
                          emptyValue={true}
                        />
                      </div>
                    </div>
                    {/* Is Claimed */}
                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("global.is-claimed")}
                        </label>
                        <Select
                          id="isClaimed"
                          name="isClaimed"
                          value={this.state.searchInput.isClaimed}
                          onChange={this.onChangeIsClaimed}
                          options={[
                            { value: '0', label: t('global.unclaimed') },
                            { value: '1', label: t('global.claimed') },
                          ]}
                          getOptionLabel="label"
                          getOptionValue="value"
                          className="filter-input"
                          emptyValue={true}
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-3">
                        <div>
                          <Button
                            typeButton="button"
                            classValue="btn btn-blue"
                            idValue="filter"
                            buttonName={t("global.filter")}
                            clicked={() => this.onSearch()}
                          />
                          &nbsp;
                          <Button
                            typeButton="button"
                            classValue="btn btn-secondary"
                            idValue="reset"
                            buttonName={t("global.reset")}
                            clicked={() => this.onReset()}
                          />
                        </div>
                      </div>             
                  </div>
                )}
              </div>

              <div className="show-btn" onClick={() => this.toggleCard()}>
                {this.state.showCard ? (
                  <AiFillMinusCircle />
                ) : (
                  <AiFillPlusCircle />
                )}
              </div>
            </div>
          </div>
          
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header pb-0">
                <div className="d-flex justify-content-between">
                  <h4 className="card-title mg-b-0">
                    {t("global.bonus-claim-list")}
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive table-hover datatable">
                 {this.state.loading ? <Skeleton count={10} /> : (
                  <DataTable
                    keyField="no"
                    data={this.state.data}
                    columns={columns}
                    activePage={this.state.activePage}
                    limit={this.state.limit}
                    totalItems={this.state.totalRecords}
                    paginationHandler={(val) => this.onChangePage(val)}
                    sizePerPageHandler={(val) => this.onChangeLimit(val)}
                    classValue="dataTable table-bordered text-justify text-center"
                    loading={this.state.loading}
                  />
                 )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Auxiliary>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBonusClaimList: (data) => dispatch(getBonusClaimList(data)),
  };
};

const mapStateToProps = (reduxState) => {
  return {
    currentUser: reduxState.currentUser.data,
    list: reduxState.bonusClaim?.list
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(BonusClaimList));
